import { IRecordIdentifier } from '../../types/interfaces/record';
import { IRecordState } from '../../types/interfaces/states';
import { RootState } from '../store';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import Recording from '../../classes/record';

const initialState: IRecordState = {
  currentRecording: undefined,
  finished: [],
  pending: [],
  identifiers: [],
};

const recordingSlice = createSlice({
  name: 'recordings',
  initialState,
  reducers: {
    addRecording(state, action: PayloadAction<Recording>) {
      state.pending.push(action.payload);
      state.identifiers.push({code: action.payload.eventId || "", type: action.payload.type || -1})
      state.currentRecording = action.payload
    },
    removeRecording(state, action: PayloadAction<Recording>) {
      let index = state.pending.findIndex((item) => {
        return item?.eventId === action.payload.eventId;
      });
      if (index !== -1) {
        state.pending.splice(index, 1);
      }
      index = state.finished.findIndex((item) => {
        return item?.eventId === action.payload.eventId;
      });
      if (index !== -1) {
        state.finished.splice(index, 1);
      }
      index = state.identifiers.findIndex((item) => {
        return item.code === action.payload.eventId;
      });
      if (index !== -1) {
        state.identifiers.splice(index, 1);
      }
      state.currentRecording = undefined
    },
    resetRecordings: (state) => {
      state.currentRecording = undefined;
      state.finished = [];
      state.pending = [];
      state.identifiers = [];
    },
    setCurrentRecording: (state, action: PayloadAction<Recording>) => {
      state.currentRecording = action.payload;
    },
    setFinishedRecordings: (state, action: PayloadAction<Recording[]>) => {
      state.finished = action.payload;
    },
    setPendingRecordings: (state, action: PayloadAction<Recording[]>) => {
      state.pending = action.payload;
    },
    setIdentifiers: (state, action: PayloadAction<IRecordIdentifier[]>) => {
      state.identifiers = action.payload;
    },
  },
});

const { actions, reducer: recordingReducer } = recordingSlice;
export const {
  addRecording,
  removeRecording,
  resetRecordings,
  setCurrentRecording,
  setFinishedRecordings,
  setPendingRecordings,
  setIdentifiers,
} = actions;
export const recordingSelector = (state: RootState) => state.recordings;
export default recordingReducer;
